const queue = []
let runningCount = 0
const maxRequestsNum = 3
async function processNextRequest() {
  if (runningCount >= maxRequestsNum || queue.length === 0) return
  runningCount += 1
  const request = queue.shift()
  try {
    await request()
  } catch (error) {
    // error
  } finally {
    runningCount -= 1
    processNextRequest()
  }
}
export default function addRequestQueue(request) {
  return new Promise((resolve, reject) => {
    queue.push(async () => {
      try {
        const result = await request()
        resolve(result)
      } catch (error) {
        reject(error)
      }
    })
    processNextRequest()
  })
}
